module.exports = __webpack_public_path__ + "static/media/solitary_01.6c45a1b7.jpg";